import * as React from "react";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";

import { ColumnFilterWrapper } from "../ColumnFilterWrapper/ColumnFilterWrapper";
import styles from "./ColumnDropdownFilter.module.css";

export interface ColumnDropdownFilterOption {
  label: string;
  value: any;
}

export type ColumnDropdownFilterMatchMode =
  `startsWith` | `contains` | `notContains` | `endsWith` | `equals` | `notEquals` |
  `in` | `notIn` | `lt` | `lte` | `gt` | `gte` | `between` |
  `dateIs` | `dateIsNot` | `dateBefore` | `dateAfter` | `custom`;

export interface ColumnDropdownFilterProps {
  dtRef: React.RefObject<DataTable<any> | null>;
  filters?: any;
  field: string;
  options: ColumnDropdownFilterOption[];
  allLabel?: string;
  toQueryValue: (value: any) => any;
  matchMode?: ColumnDropdownFilterMatchMode;
  /** Короткая подпись выбранного значения. В списке опций всегда остаётся полный label. */
  getValueLabel?: (option: ColumnDropdownFilterOption) => React.ReactNode;
}

export const ColumnDropdownFilter: React.FC<ColumnDropdownFilterProps> = ({
  dtRef,
  filters,
  field,
  options,
  allLabel = `Все`,
  toQueryValue,
  matchMode = `equals`,
  getValueLabel,
}) => {
  const [value, setValue] = React.useState<any>(0);
  const filterEntry = filters?.[field];

  React.useEffect(() => {
    const existing = filterEntry?.value;
    if (existing === undefined || existing === null || existing === ``)
      return;
    setValue(Array.isArray(existing) ? existing[0] ?? 0 : existing);
  }, [filterEntry, field]);

  const resolvedOptions = React.useMemo(
    () => [{ label: allLabel, value: 0 }, ...options],
    [options, allLabel]
  );

  const onChange = (e: { value: any }) => {
    setValue(e.value);
    dtRef.current?.filter(toQueryValue(e.value), field, matchMode);
  };

  const onClear = () => {
    setValue(0);
    dtRef.current?.filter(toQueryValue(0), field, matchMode);
  };

  return (
    <ColumnFilterWrapper showClear={!!value} onClear={onClear} hasTrailingIcon>
      <Dropdown
        className={styles[`filter-dropdown`]}
        panelClassName={styles[`filter-panel`]}
        value={value}
        options={resolvedOptions}
        onChange={onChange}
        valueTemplate={getValueLabel
          ? (option: ColumnDropdownFilterOption) => (option ? getValueLabel(option) : null)
          : undefined}
        scrollHeight="auto"
        appendTo={document.body} />
    </ColumnFilterWrapper>
  );
};
